module.exports = __webpack_public_path__ + "img/banner-易企盈.4fd413db.svg";